import './theme.less';
import './main.less';
import PropTypes from 'prop-types';
import cn from 'classname';
import React, { Component } from 'react';
import { Link } from 'react-router';
import Sidebar from './components/main';
import DebtWidget from './components/debt-widget/main';

function SidebarWrap({
	intl, debt, logout, menuConfig, menuToggle, userData, availableCurrencies, selectedRow,
	toggleNested, unnestedIndex
}) {
	const isShowedDebtWidget = userData.permissions.indexOf('total_debt_view') > -1
		|| process.env.CPA_ENV === 'rocket';
	const items = menuConfig.items;

	return (
		<Sidebar opened={menuConfig.isOpen} toggleOpened={menuToggle} intl={intl}>
			<Sidebar.Top>
				<Sidebar.Logo />
				<Sidebar.Menu>
					{items.map((item, i) =>
						<Sidebar.Menu.Item
							key={i}
							icon={item.icon}
							isActive={menuConfig.activeItem[0] === i}
							isHidden={!!item.nestedFromIndex && (!unnestedIndex || !item.nestedFromIndex === unnestedIndex)}
							triangle={Array.isArray(item.subitems)}
							notifications={item.iconCount || null}
							selectedRow={selectedRow}
							itemIndex={item.index}
							hasNestedItems={item.hasNestedItems}
							nestedFromIndex={item.nestedFromIndex}
						>
							{item.uri
								? <Link to={item.uri} activeClassName="active">
									<span className="icon" />
									<span className="title">{item.title}</span>
									{
										item.hasNestedItems &&
										<span
											className={cn({
												'nested-triangle': true,
												'nested-triangle-rotated': unnestedIndex === item.index
											})}
											onClick={toggleNested.bind(null, item.index)}
										/>
									}
								</Link>
								: <a href="javascript:;">
									<span className="icon" />
									<span className="title">{item.title}</span>
								</a>}

							{Array.isArray(item.subitems) &&
								<Sidebar.Menu.Submenu>
									{item.subitems.map((subitem, j) =>
										<Sidebar.Menu.Subitem
											key={j}
											isActive={menuConfig.activeItem[0] === i && menuConfig.activeItem[1] === j}
											icon={subitem.icon}
											notifications={subitem.iconCount || null}
										>
											<Link to={subitem.uri} activeClassName="active">
												<span className="icon" />
												<span className="title">{subitem.title}</span>
											</Link>
										</Sidebar.Menu.Subitem>
									)}
								</Sidebar.Menu.Submenu>}
						</Sidebar.Menu.Item>
					)}
				</Sidebar.Menu>
			</Sidebar.Top>
			<Sidebar.Bottom>
				{
					isShowedDebtWidget &&
					<DebtWidget value={debt} availableCurrencies={availableCurrencies} />
				}
				<Link to={'/profile'} className="profile-link" activeClassName="active">
					<Sidebar.Buttons.Button icon="profile">
						{intl('Profile')}
					</Sidebar.Buttons.Button>
				</Link>
				<Sidebar.Buttons.Button onClick={logout} icon="logout">
					{intl('Sign out')}
				</Sidebar.Buttons.Button>
			</Sidebar.Bottom>
		</Sidebar>
	);
}

SidebarWrap.propTypes = {
	intl: PropTypes.func,
	logout: PropTypes.func,
	userData: PropTypes.object,
	debt: PropTypes.object,
	menuConfig: PropTypes.object,
	menuToggle: PropTypes.func
};

class SidebarWrapContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { selectedRow: '', unnestedIndex: ''};
		this.toggleNested = this.toggleNested.bind(this);
	}
	toggleNested(index, e) {
		e && e.stopPropagation();
		e && e.preventDefault();
		this.setState(state => ({ unnestedIndex: state.unnestedIndex === index ? '' : index }));
	}
	render() {
		return <SidebarWrap
			{...this.props}
			toggleNested={this.toggleNested}
			{...this.state}
		/>;
	}
}

export default SidebarWrapContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/main.js